import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-design-icon',
	templateUrl:'./MaterialDesignIconPluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconPluginCompPage
{
	mdContent_1063 = `\`\`\`java
import com.jwebmp.plugins.materialdesignicons.MaterialDesignIcon;
\`\`\``;
	mdContent_1064 = `\`\`\`java
MaterialDesignIcons icon
\`\`\``;
	mdContent_1065 = `\`\`\`java
MaterialDesignIconThemes theme, MaterialDesignIcons icon
\`\`\``;
	mdContent_1066 = `\`\`\`java
MaterialDesignIconThemes theme, MaterialDesignIcons icon, MaterialDesignIconSize size
\`\`\``;
	mdContent_1067 = `\`\`\`java
MaterialDesignIconThemes theme, MaterialDesignIcons icon, MaterialDesignIconSize size, MaterialDesignIconColours colour
\`\`\``;
	mdContent_1068 = `\`\`\`java
var icon = new MaterialDesignIcon&lt;&gt;(MaterialDesignIcons.home);
\`\`\``;
	mdContent_1069 = `\`\`\`java
var icon = new MaterialDesignIcon&lt;&gt;(
    MaterialDesignIconThemes.Outlined,
    MaterialDesignIcons.settings,
    MaterialDesignIconSize.$48,
    MaterialDesignIconColours.Dark);
\`\`\``;
}
